import React, {useEffect} from 'react';

import {setWindowTitle} from 'BenchlingUtil';
import ChemicalCounterpartCreateFromCSVPage from 'chemistry/ChemicalCounterpartCreateFromCSVPage';
import {
  createSaltsFromFile,
  SALT_LIBRARY_URL,
  TEMPLATE_BULK_SALTS_CSV_LINK,
  validateSaltsFromFile,
} from 'chemistry/ChemistryDAO';
import {getApolloClient} from 'graphql-client/ApolloClient';

import {SALT_LIBRARY_QUERY} from './SaltLibraryQuery';

export default function SaltCreateFromCSVPage(): JSX.Element | null {
  useEffect(() => {
    setWindowTitle('Add salts and solvates');
  }, []);

  return (
    <ChemicalCounterpartCreateFromCSVPage
      counterpartName="salt or solvate"
      counterpartNamePlural="salts and solvates"
      libraryTitle="Salt & Solvate library"
      libraryUrl={SALT_LIBRARY_URL}
      templateCSVLink={TEMPLATE_BULK_SALTS_CSV_LINK}
      validate={validateSaltsFromFile}
      createFromFile={createSaltsFromFile}
      onImportSuccess={async () => {
        await getApolloClient().refetchQueries({include: [SALT_LIBRARY_QUERY]});
      }}
      dataTestComponent="SaltCreateFromCSVPage"
    />
  );
}
